import React from 'react';

import { Box, Button, Dialog, H1, IconButton, Link, Logo, Text, WorkflowHeader } from '@betterment/samba-react';

import { locationAssign } from '../Shared/path-helpers';

interface Props {
  title?: string;
  backPath?: string;
  closePath?: string;
  logoPath?: string;
  showExitDialog?: boolean;
}

interface ExitDialogProps {
  closePath: string;
}

const ExitDialog: React.FC<ExitDialogProps> = ({ closePath }) => (
  <Dialog overlay="default">
    <Dialog.Trigger asChild={true}>
      <IconButton name="X" label="Close" />
    </Dialog.Trigger>
    <Dialog.Content css={{ display: 'flex', flexDirection: 'column', p: 'space.400', gap: 'space.400' }} size="medium">
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.150' }}>
        <Dialog.Title asChild={true}>
          <H1 variant="title200">Are you sure you want to exit?</H1>
        </Dialog.Title>
        <Dialog.Description asChild={true}>
          <Text variant="text100">Your progress will not be saved, but you can start over any time.</Text>
        </Dialog.Description>
      </Box>
      <Box css={{ display: 'flex', gap: 'space.200' }}>
        <Button onClick={() => locationAssign(closePath)}>Yes, exit</Button>
        <Dialog.Close asChild={true}>
          <Button variant="solidSecondary">Never mind</Button>
        </Dialog.Close>
      </Box>
    </Dialog.Content>
  </Dialog>
);

const RolloverWorkflowHeader: React.FC<Props> = ({ title, backPath, closePath, logoPath, showExitDialog }) => (
  <WorkflowHeader>
    <WorkflowHeader.Leading css={{ display: 'flex', alignItems: 'center', gap: 'space.200' }}>
      {backPath && <IconButton name="LeftArrowSmall" label="Back" onClick={() => locationAssign(backPath)} />}
      {logoPath && (
        <Link href={logoPath} aria-label="Betterment home" variant="ghostPrimary">
          <Logo type="signature" css={{ height: 'size.200', '& svg': { display: 'block' } }} />
        </Link>
      )}
    </WorkflowHeader.Leading>
    <WorkflowHeader.Title>{title}</WorkflowHeader.Title>
    <WorkflowHeader.Trailing>
      {closePath && showExitDialog ? (
        <ExitDialog closePath={closePath} />
      ) : (
        closePath && <IconButton name="X" label="Close" onClick={() => locationAssign(closePath)} />
      )}
    </WorkflowHeader.Trailing>
  </WorkflowHeader>
);

export default RolloverWorkflowHeader;
